import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IWebsiteWPVersionState} from "../reducers/website-wp-version.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getWebsiteWPVersionState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.websiteWPVersion);

export const getWpVersion = (websiteId: number) => createSelector(getWebsiteWPVersionState,
  (state: IWebsiteWPVersionState) =>
    (state.entities[websiteId] && state.entities[websiteId].entities) ? state.entities[websiteId].entities : null
);

export const getWpVersionLoading = (websiteId: number) => createSelector(getWebsiteWPVersionState,
  (state: IWebsiteWPVersionState) =>
    state.entities[websiteId].loading
);

export const getWpVersionLoaded = (websiteId: number) => createSelector(getWebsiteWPVersionState,
  (state: IWebsiteWPVersionState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
